import { Box, Button, TextField, Typography } from '@mui/material'
import React, { ReactNode, useEffect, useState} from 'react'
import SuccessLoginModal from '../shared/molecule/SuccessLoginModal'
import { useProfileForm } from '../../utils/hooks/useProfileForm'
import { useAppDispatch } from '../../redux/storeExports'
import { putProfile, setupProfile } from '@meprism/shared/src/redux/peopleFinder/PeopleFinderSlice'
import { fontssign } from '../../theme/OnboardingTheme'
import { useNavigate } from 'react-router-dom'
import { Grant } from '@meprism/shared/src/redux/product/ProductTypes'
import { showModalForGrant, isGrantFromCodeRedemption } from '@meprism/shared/src/redux/product/ProductSlice'
import {FetchProfile} from "@meprism/shared/src/redux/profile/ProfileSlice";
import {ProfileSlice} from "@meprism/shared/src/redux/profile/ProfileTypes";
import AnalyticsManager from '../../services/AnalyticsManager'
import { formatPhoneNumbers } from '../../utils/helpers'
import { logFirebaseEvent } from '../../utils/firebaseConfig'
import { logCustomMetapixelEvent } from '../../utils/MetapixelManager'
interface ConsentAgreementModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  name: string
  setName: (name: string) => void
  textInputProps: any
  extra?: ReactNode
  onSubmit?: () => void
  grant?: Grant
}

// Important: if you change this file, you must also increment the
// version in shared/redux/ProfileSlice
// so that we know how to differentiate user agreements

const ConsentAgreement = (props: ConsentAgreementModalProps) => {

    const [SuccessLoginOpen, SetSuccessLoginOpen] = useState(false)
    const [fetchedProfile, setFetchedProfile] = useState<ProfileSlice>()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    useEffect(() => {
      const fetchProfile = async () => {
        const fetchedProfiledata = await dispatch(FetchProfile()).unwrap();
        setFetchedProfile(fetchedProfiledata)
      }
      fetchProfile();
    }, [dispatch]);
    
    const profileForm = useProfileForm({
      onSubmitSuccess: () => {
        dispatch(putProfile()).unwrap()
        dispatch(setupProfile()).unwrap()
        SetSuccessLoginOpen(true);
      },
      onSubmitError: (error) => {
        // Handle error actions here
        console.error('Error submitting form:', error);
      },
    });
const textStyle = {
  ...fontssign.Allison.Regular,
  fontSize: '50px',
  color:'#fff'
}

// Determine if we should show the modal based on grant source
const showModal = showModalForGrant(props.grant);

// Determine if the grant is from code redemption
const isFromCodeRedemption = isGrantFromCodeRedemption(props.grant);

// Determine if we should show the modal based on grant source and code redemption
// We want to hide the modal if either showModal is true OR isFromCodeRedemption is true
const shouldShowModal = showModal && !isFromCodeRedemption;

const handleSignAndAdopt = async () => {
  try {
    const values = profileForm.watch();
    const grantSource = props.grant?.grant_source;

    // Trigger the form submission
    await profileForm.submitHandler({
      ...values,
      phoneNumber: formatPhoneNumbers(values.phoneNumber),
      last_scan_initiated_at: fetchedProfile?.last_scan_initiated_at,
      mp_auth_letter_signature: props.name, // Include the signature
    }, {
      _is_on_boarding_request: grantSource === 'corporate_grant' || grantSource === 'family_grant',
    } as any);

    AnalyticsManager.trackTypedEvent(
      {event: 'Auth Letter Signed - Web', source: "Web App", 
      grant: props.grant?.grant_source? props.grant.grant_source : '', sku: props.grant?.sku? props.grant.sku: ''}
    )

    if(grantSource === 'corporate_grant' || grantSource === 'family_grant'){
      AnalyticsManager.trackTypedEvent({event: 'Onboarding Completed - Web', source: "Web App"})
      logFirebaseEvent('Onboarding Completed - Web')
      logCustomMetapixelEvent('Onboarding Completed - Web')
    }
    
    // Only navigate if modal is not shown
    if (!shouldShowModal) {
      // Navigate to dashboard after a short delay
      setTimeout(() => {
        navigate('/dashboard');
      }, 1500);
    }
  } catch (error) {
    console.error('Error during form submission:', error);
  }
};

  // Determine if we should show the modal based on grant value


  return (

      <Box >
        <Typography variant="h2" sx={{ textAlign: 'left', mb: '20px' }}>
          AUTHORIZATION LETTER
        </Typography>
        {props.extra && props.extra}
        <Typography variant="body2" sx={{ mt: props.extra ? '12px' : '0px' }}>
          I, {props.name === '' ? 'YOUR NAME' : props.name}, hereby authorize
          mePrism Inc. (“mePrism”) to act as my authorized agent under the
          California Consumer Privacy Act (CCPA) and all other current and
          future privacy and data security laws. This authorization grants
          mePrism the power to take any necessary and reasonable actions to
          protect my privacy rights, including but not limited to removing,
          suppressing, or opting-out my personal information from any unwanted
          sources.
        </Typography>
        <Typography variant="body2">
          mePrism is authorized to contact third parties, such as data brokers,
          people search companies, and data aggregators, to exercise my rights
          to delete and opt-out of the sale and disclosure of my personal
          information. I acknowledge that mePrism will not be held liable for
          any actions taken under this authorization, provided that they act
          reasonably.
        </Typography>
        <Typography variant="body2">
          This authorization will remain in full force and effect until I cancel
          my service with mePrism.
        </Typography>
        <Box
          sx={{
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
            mt: '20px',
          }}>
          {/* <Typography variant={'body2'}>Signed: </Typography> */}
          <TextField
            value={props.name}
            placeholder='Signature'
            onChange={(event) => props.setName(event.target.value)}
            sx={{  mb: '0px', pb: '0px'}}
            {...props.textInputProps}
          />

          <Typography sx={{ ml: '10px', ...textStyle, }}>
            {props.name}
          </Typography>
        </Box>
        <Box
          sx={{
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
            mt: '10px',
          }}>
          <Typography variant={'body2'}>Dated: </Typography>
          <Typography variant={'body2'} sx={{ ml: '10px' }}>
            {new Date().toLocaleDateString()}{' '}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 'auto',
            mt: '20px',
            
          }}>
          <Button
            // variant={'contained'}
            style={{color:'#ffffff',width:'100%'}}
            disabled={props.name === ''}
            onClick={() => handleSignAndAdopt()}
            >
            Sign and adopt as signature
          </Button>
          {shouldShowModal && (
            <SuccessLoginModal 
              open={SuccessLoginOpen}
              setOpen={SetSuccessLoginOpen}
            />
          )}
        </Box>
      </Box>
  )
}

export default ConsentAgreement
